const UseLocalBackend = false;

const BASE_URL_NODE_LOCAL = "http://localhost:4000";
const BASE_URL_FLASK_LOCAL = "http://localhost:8070/api";

const BASE_URL_NODE_CLOUD = "https://dev-classification.altroverse.ai";
const BASE_URL_FLASK_CLOUD =
  "https://dev-backend-classification.altroverse.ai/api";

export const BASE_URL_NODE = UseLocalBackend
  ? BASE_URL_NODE_LOCAL
  : BASE_URL_NODE_CLOUD;
export const BASE_URL_FLASK = UseLocalBackend
  ? BASE_URL_FLASK_LOCAL
  : BASE_URL_FLASK_CLOUD;

// Use FLASK as the main BASE_URL for the common services
export const BASE_URL = BASE_URL_FLASK;

// API Endpoints
// Auth endpoints
export const LOGIN = "auth/login";
export const REGISTER = "auth/register";
export const REFRESH_TOKEN = "auth/refresh";

// Admin endpoints
export const ADMIN_USERS = "admin/users";
export const ADMIN_TASKS = "admin/tasks";
export const ADMIN_TASK = "admin/task";
export const ADMIN_ASSIGN_TASK = "admin/assign_task";
export const ADMIN_TASK_STATISTICS = "admin/get_task_statistics";

// User endpoints
export const USER_TASKS = "user/tasks";
export const USER_TASK_STATISTICS = "user/task_statistics";
export const USER_TASK_VERIFICATION = "user/tasks/verification";
export const USER_TASK_VERIFY = "user/tasks/verify";

// Batch endpoints
export const ADMIN_BATCHES = "admin/batches";
export const ADMIN_BATCH = "admin/batch";
export const ADMIN_BATCH_STATISTICS = "admin/batch_stats";

// Model endpoints
export const ADMIN_MODELS = "admin/models";
export const USER_MODELS = "user/models";

// Dashboard endpoints
export const ADMIN_DASHBOARD_STATS = "admin/dashboard";

// Additional endpoints from your example
export const ASSINGED_TASKS = "user/assigned_tasks";
export const CREATE_TASK = "admin/task";
export const DOWNLOAD_FILE_URL = "admin/download_file";
export const GET_COUNT = "admin/get_count";
export const GET_TASKDATA_COUNT = "admin/get_taskdata_count";
export const UPDATE_TASK_TYPE = "admin/update_task_type";
export const UPLOAD_TO_ASSET_LIBRARY = "admin/upload_to_asset_library";
